import 'particles.js';

const PARTICLES_COLOR = getComputedStyle(document.body).getPropertyValue('--color-particles').trim();

const mediaQuery = window.matchMedia('(prefers-reduced-motion)');

export const particlesJsCircle = (el) => {
  window.particlesJS(el, {
    particles: {
      number: { value: 300 },
      color: { value: PARTICLES_COLOR },
      size: {
        value: 8,
        random: true,
        anim: { enable: false, speed: 40, size_min: 4, sync: false }
      },
      line_linked: {
        enable: true,
        distance: 100,
        color: PARTICLES_COLOR,
        opacity: 0.8,
        width: 1
      },
      move: {
        enable: true,
        speed: mediaQuery.matches ? 0 : 0.65,
        direction: 'none',
        out_mode: 'bounce'
      }
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: { enable: true, mode: 'repulse' },
        resize: true
      },
      modes: {
        repulse: { distance: 20, duration: 0.4 }
      }
    },
    retina_detect: true
  });
};

export const particlesJsAbstract = (el) =>
  window.particlesJS(el, {
    particles: {
      number: { value: 200 },
      color: { value: PARTICLES_COLOR },
      size: {
        value: 8,
        random: true,
        anim: { enable: false, speed: 40, size_min: 4, sync: false }
      },
      line_linked: {
        enable: true,
        distance: 100,
        color: PARTICLES_COLOR,
        opacity: 0.8,
        width: 1
      },
      move: {
        enable: true,
        speed: mediaQuery.matches ? 0 : 0.65,
        direction: 'none',
        out_mode: 'bounce'
      }
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: { enable: true, mode: 'repulse' },
        resize: true
      },
      modes: {
        repulse: { distance: 20, duration: 0.4 }
      }
    },
    retina_detect: true
  });
